import React from 'react';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";

function ClientReportCode(props){

  const {RightLinkSelection, updateRightLinkSelection, updateInstallationLinkSelection, updateLinkSelection } = useContext(MyContext);
  const active = "BIcon active";
  const notActive = "BIcon";

  const update = () =>{
    
    updateInstallationLinkSelection("Bank")
    updateLinkSelection("")
  }
  

    return (
       
        <>
        
      
<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>


<div className="card-body">
<div style={{display: "flex"}}>

    <span style={{width:"91%", display:"flex"}}>

<span style={{marginRight:"40px"}}>
<div style={{display: "flex"}}>
    
    <p className="card-title"><strong>Date:</strong></p></div>
  
    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Date of Report:</strong> {props.date}</span>
    
   
    </div>



</span>
<span style={{marginRight:"40px"}}>

    <p><strong>ID: </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">fingerprint</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.id}</span>
  
  </div>

</span>




<span style={{marginRight:"40px"}}>

    <p><strong>Rack Name: </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">dns</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.RackName}</span>
  
  </div>

</span>

<span style={{marginRight:"40px"}}>

    <p><strong>Battery Name: </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.BatteryName}</span>
  
  </div>

</span>


<span style={{marginRight:"40px", width:"20%"}}>

    <p><strong>Bank Name: </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.name}</span>
  
  </div>

</span>
<span className='plantIcon5' style={{paddingTop:"10px"}}>
               
                    <p style={{fontSize:"30px"}}><span class="material-symbols-rounded">battery_5_bar</span>
                    <strong>{props.voltage}v</strong>
                    </p>
                </span>


</span>



<span style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("graphs")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"7px"}} >query_stats</span> <span style={{paddingTop:"12px", paddingLeft:"5px"}}>Battery Graph</span></span>

</span>

{/* 

<span style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("AllBatteries")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >battery_5_bar</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>All Cells</span></span>

</span>

<span  style={{width:"14%", paddingRight:"20px"}}>

<span className="BIcon3" onClick={() => updateInstallationLinkSelection("Information")} style={{height:"100%" , margin: "0px",  paddingTop:"13px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >info</span> <span  style={{paddingTop:"2px", paddingLeft:"5px"}}>Cells Info </span></span>

</span>
*/}



</div>
</div>
</div>

             

        </>
    )
}

export default ClientReportCode;